"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WINDOW_RESIZE = exports.WINDOW_FOCUS = exports.WINDOW_BLUR = exports.VIBRATE_TOGGLE = exports.UPDATE_SERVER_TIME = exports.ScreenSize = exports.SPIN_ON_SPACE_TOGGLE = exports.SOUND_TOGGLE = exports.SET_RESOLUTION = exports.SET_AUTO_PLAY_ROUNDS = exports.SERVER_CONFIG = exports.MUSIC_TOGGLE = exports.HIDE_SPLASH_SCREEN = exports.HIDE_CURRENCY_SIGN_TOGGLE = exports.FAST_PLAY_TOGGLE = exports.CURRENCY_SIGN_HIDE_TOGGLE = exports.AUTO_ADJUST_BET_TOGGLE = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ScreenSize = exports.ScreenSize = /*#__PURE__*/_createClass(function ScreenSize() {
  _classCallCheck(this, ScreenSize);
  /** 
   * width to height (width/height) ratio
   *  */
  _defineProperty(this, "ratio", void 0);
  _defineProperty(this, "height", void 0);
  _defineProperty(this, "width", void 0);
  _defineProperty(this, "orientation", void 0);
  _defineProperty(this, "channel", void 0);
  /**
   * Set by the game during start when it decides what game assets to load. above 2 is HD.
   */
  _defineProperty(this, "resolution", void 0);
  /**
   * based on width of 1200 as native.
   */
  _defineProperty(this, "scaleFactor", void 0);
  /**
   * based on width of 1920x1080 as native. HD desktop
   */
  _defineProperty(this, "scaleFactorHd", void 0);
  /**
   * The difference between window.innerHeight and document.body.offsetHeight;
   * This is used to detect when there is a potential address bar down in landscape ios safari
   * Value is window.innerHeight - document.body.offsetHeight;
   */
  _defineProperty(this, "bodyHeightOffset", void 0);
});
var WINDOW_BLUR = exports.WINDOW_BLUR = "WINDOW_BLUR";
var WINDOW_FOCUS = exports.WINDOW_FOCUS = "WINDOW_FOCUS";
var WINDOW_RESIZE = exports.WINDOW_RESIZE = "WINDOW_RESIZE";
var SERVER_CONFIG = exports.SERVER_CONFIG = "SERVER_CONFIG";
var UPDATE_SERVER_TIME = exports.UPDATE_SERVER_TIME = "UPDATE_SERVER_TIME";
var SOUND_TOGGLE = exports.SOUND_TOGGLE = "SOUND_TOGGLE";
var MUSIC_TOGGLE = exports.MUSIC_TOGGLE = "MUSIC_TOGGLE";
var FAST_PLAY_TOGGLE = exports.FAST_PLAY_TOGGLE = "FAST_PLAY_TOGGLE";
var AUTO_ADJUST_BET_TOGGLE = exports.AUTO_ADJUST_BET_TOGGLE = "AUTO_ADJUST_BET_TOGGLE";
var SPIN_ON_SPACE_TOGGLE = exports.SPIN_ON_SPACE_TOGGLE = "SPIN_ON_SPACE_TOGGLE";
var HIDE_CURRENCY_SIGN_TOGGLE = exports.HIDE_CURRENCY_SIGN_TOGGLE = "HIDE_CURRENCY_SIGN_TOGGLE";
var VIBRATE_TOGGLE = exports.VIBRATE_TOGGLE = "VIBRATE_TOGGLE";
var SET_RESOLUTION = exports.SET_RESOLUTION = "SET_RESOLUTION";
var HIDE_SPLASH_SCREEN = exports.HIDE_SPLASH_SCREEN = "HIDE_SPLASH_SCREEN";
var SET_AUTO_PLAY_ROUNDS = exports.SET_AUTO_PLAY_ROUNDS = "SET_AUTO_PLAY_ROUNDS";
var CURRENCY_SIGN_HIDE_TOGGLE = exports.CURRENCY_SIGN_HIDE_TOGGLE = "CURRENCY_SIGN_HIDE_TOGGLE";

//Actions
//# sourceMappingURL=types.js.map